import { c as _c } from "react/compiler-runtime";
import { Box, VStack } from '@chakra-ui/react';
import { ArticleHero } from '@src/components/sco/Education/ArticleLanding/ArticleHero';
import { ArticleList } from '@src/components/sco/Education/ArticleSearch/ArticleList';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import ContentIntro from '@src/components/sco/Education/Other/ContentIntro';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { useWindow } from '@src/hooks/useWindow';
import { useParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';
type ArticleSearchProps = {
  articleType: 'ExpertAdvice' | 'FounderStory' | 'BlogPost';
  typeTitle?: string;
  typeSlug?: string;
};
export const ArticleSearch = props => {
  const $ = _c(37);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const educationContext = useEducationContext();
  const window = useWindow();
  useParams();
  const [showHero, setShowHero] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = hasResults => {
      setShowHero(hasResults);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleVideoListResults = t0;
  let t1;
  if ($[1] !== educationContext || $[2] !== window?.location?.href) {
    t1 = () => {
      const breadcrumbs = [{
        title: "Articles",
        href: "/articles"
      }, {
        title: `${[...educationContext.activeTerms.map(_temp), educationContext.activeKeywords && `"${educationContext.activeKeywords}"`].filter(Boolean).join(" + ")}`,
        href: window?.location?.href
      }];
      if (educationContext.activeSection === "articles.landing") {
        breadcrumbs[0].title = "Articles";
        breadcrumbs[0].href = "/articles";
      } else {
        if (educationContext.activeSection === "founder-interviews.landing") {
          breadcrumbs[0].title = "Founder Interviews";
          breadcrumbs[0].href = "/founder-interviews";
        }
      }
      educationContext.setBreadcrumbs(breadcrumbs);
    };
    $[1] = educationContext;
    $[2] = window?.location?.href;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== educationContext.activeKeywords || $[5] !== educationContext.activeSection || $[6] !== educationContext.activeTerms) {
    t2 = [educationContext.activeKeywords, educationContext.activeTerms, educationContext.activeSection];
    $[4] = educationContext.activeKeywords;
    $[5] = educationContext.activeSection;
    $[6] = educationContext.activeTerms;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  if ($[8] !== educationContext.activeKeywords || $[9] !== educationContext.activeTerms || $[10] !== props.articleType || $[11] !== showHero) {
    t3 = showHero && <Box width="full"><ArticleHero articleType={props.articleType} keywords={educationContext.activeKeywords} termSlugs={educationContext.activeTerms.map(_temp2)} /></Box>;
    $[8] = educationContext.activeKeywords;
    $[9] = educationContext.activeTerms;
    $[10] = props.articleType;
    $[11] = showHero;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== getBreakpointValue) {
    t4 = getBreakpointValue([10, 10, 10, 20, 20]);
    $[13] = getBreakpointValue;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== getBreakpointValue) {
    t5 = getBreakpointValue([10, 10, 10, 10, 20]);
    $[15] = getBreakpointValue;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== educationContext.activeKeywords || $[18] !== educationContext.activeSection || $[19] !== educationContext.activeTerms) {
    t6 = educationContext.activeSection === "articles.landing" ? <ContentIntro description="Hand-curated advice from startup Founders on every aspect of starting a company." title={<>{"Expert "}{educationContext.activeTerms.map(_temp3).join(" + ")}{" "}{educationContext.activeKeywords && educationContext.activeTerms.length > 0 && "+"}{" "}<Box as="span" textTransform="capitalize">{educationContext.activeKeywords}</Box>{" "}Advice</>} /> : <ContentIntro description="Personal, candid interviews with the most world-changing Founders of all time." title="Origin Stories of Legendary Founders" />;
    $[17] = educationContext.activeKeywords;
    $[18] = educationContext.activeSection;
    $[19] = educationContext.activeTerms;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const t7 = props.articleType;
  const t8 = educationContext.activeKeywords;
  let t9;
  if ($[21] !== educationContext.activeTerms) {
    t9 = educationContext.activeTerms.map(_temp4);
    $[21] = educationContext.activeTerms;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== educationContext.activeKeywords || $[24] !== props.articleType || $[25] !== props.typeSlug || $[26] !== props.typeTitle || $[27] !== t9) {
    t10 = <ArticleList articleType={t7} keywords={t8} showSummaries={true} termSlugs={t9} typeSlug={props.typeSlug} typeTitle={props.typeTitle} onResults={handleVideoListResults} />;
    $[23] = educationContext.activeKeywords;
    $[24] = props.articleType;
    $[25] = props.typeSlug;
    $[26] = props.typeTitle;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t4 || $[31] !== t5 || $[32] !== t6) {
    t11 = <VStack align="center" gap={t4} maxWidth="100em" paddingX={t5} width="full">{t6}{t10}</VStack>;
    $[29] = t10;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t3) {
    t12 = <VStack align="center" gap={20} justify="stretch" width="full" marginBottom={40}>{t3}{t11}</VStack>;
    $[34] = t11;
    $[35] = t3;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
};
function _temp(t) {
  return t.name;
}
function _temp2(t_0) {
  return t_0.slug;
}
function _temp3(t_1) {
  return t_1.name;
}
function _temp4(t_2) {
  return t_2.slug;
}